import layoutActionTypes from "constants/layout";
import profileActionTypes from "constants/profile";
import { DARK, LIGHT, ThemeModel } from "constants/theme";
import { IUserModel } from "helpers/models/user";
import { generateLinks, generateRoutes, generateRoutesObj } from "helpers/paths";
import { createRolesObject } from "helpers/roles";
import { Action, handleActions } from "redux-actions";

const { TOGGLE_FULLSCREEN, TOGGLE_THEME, TOGGLE_SIDEBAR, PUT_DATA, CLEAR_DATA } = layoutActionTypes;
const { GET_INITIAL_PROFILE } = profileActionTypes;
const storedCurrentUser: IUserModel = localStorage.getItem("currentUser")
    ? JSON.parse(localStorage.getItem("currentUser") || "")
    : false;

const themeValue = localStorage.getItem("theme");

function routesLinks(currentUser: IUserModel) {
    if (!currentUser) {
        return {};
    }
    const roles = createRolesObject(currentUser.roles);
    const routesObj = generateRoutesObj(roles, currentUser);
    return { routes: generateRoutes(routesObj), links: generateLinks(routesObj) };
}

type RoutesAndLinksModel = ReturnType<typeof routesLinks>;

const initialState = {
    fullscreen: false,
    sidebarOpened: false,
    theme: ([null, undefined, "null"].includes(themeValue) ? LIGHT : themeValue) as ThemeModel,
    ...(storedCurrentUser ? routesLinks(storedCurrentUser) : { routes: [], links: [] }),
    data: {},
};

type State = RoutesAndLinksModel & {
    fullscreen: boolean;
    sidebarOpened: boolean;
    theme: ThemeModel;
    data: {};
};

type GetInitialPayload = { currentUser: IUserModel };
type PutDataPayload = { data: {} };
type ToggleSidebarPayload = boolean;

type CombinedPayload = GetInitialPayload | PutDataPayload | ToggleSidebarPayload;

export default handleActions<State, CombinedPayload>(
    {
        [GET_INITIAL_PROFILE]: (state, { payload }: Action<GetInitialPayload>) => ({
            ...state,
            ...routesLinks(payload?.currentUser),
        }),
        [TOGGLE_FULLSCREEN]: (state) => ({
            ...state,
            fullscreen: !state.fullscreen,
        }),
        [TOGGLE_THEME]: (state) => ({
            ...state,
            theme: state.theme === DARK ? LIGHT : DARK,
        }),
        [TOGGLE_SIDEBAR]: (state, { payload }) => ({
            ...state,
            sidebarOpened: !!payload,
        }),
        [PUT_DATA]: (state, { payload }) => ({
            ...state,
            data: payload,
        }),
        [CLEAR_DATA]: (state) => ({
            ...state,
            data: {},
        }),
    },
    initialState,
);
